/* GIPPEUN v2 — shared behaviors (theme-v2)
   - .g2-fade reveal on scroll
   - [data-g2-hv] product cards: hover video (preload near viewport, play on hover, next video on next hover)
   - [data-g2-scroll="prev|next"][aria-controls] row arrows
   - [data-g2-play] video sound/visibility helpers are section-specific
*/
(function () {
  'use strict';
  if (window.G2) return;
  var d = document, w = window;
  var mq = function (q) { return !!(w.matchMedia && w.matchMedia(q).matches); };
  var reduce = mq('(prefers-reduced-motion: reduce)');
  var canHover = mq('(hover: hover) and (pointer: fine)');

  d.documentElement.classList.add('gp-js');

  function each(root, sel, fn) {
    var list = (root || d).querySelectorAll(sel);
    for (var i = 0; i < list.length; i++) fn(list[i], i);
  }

  /* ---------- reveal ---------- */
  var fadeIO = null;
  function initFade(root) {
    if (reduce || !('IntersectionObserver' in w)) {
      each(root, '.g2-fade', function (el) { el.classList.add('is-in'); });
      return;
    }
    if (!fadeIO) {
      fadeIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); fadeIO.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    }
    each(root, '.g2-fade:not(.is-in)', function (el) { fadeIO.observe(el); });
  }

  /* ---------- hover video cards ---------- */
  function initHoverVideo(root) {
    each(root, '[data-g2-hv]:not([data-g2-hv-ready])', function (card) {
      card.setAttribute('data-g2-hv-ready', '1');
      var vid = card.querySelector('video[data-g2-hv-video]');
      if (!vid) return;
      vid.muted = true; vid.defaultMuted = true; vid.playsInline = true;
      var list = [];
      try { list = (JSON.parse(card.getAttribute('data-g2-hv-list') || '[]') || []).filter(Boolean); } catch (e) { list = []; }
      var idx = -1;
      if (list.length) { idx = Math.floor(Math.random() * list.length); vid.src = list[idx]; }
      var buffered = false;
      function preload() {
        if (buffered) return; buffered = true;
        try { vid.preload = 'auto'; vid.load(); } catch (e) {}
      }
      if (!canHover) return; // touch: keep the still image
      if ('IntersectionObserver' in w) {
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) { preload(); io.disconnect(); } });
        }, { rootMargin: '300px' });
        io.observe(card);
      } else { preload(); }
      card.addEventListener('mouseenter', function () {
        if (reduce) return;
        preload();
        card.classList.add('is-playing');
        try { vid.currentTime = 0; } catch (e) {}
        var p = vid.play(); if (p && p.catch) p.catch(function () {});
      });
      card.addEventListener('mouseleave', function () {
        card.classList.remove('is-playing');
        try { vid.pause(); vid.currentTime = 0; } catch (e) {}
        if (list.length > 1) {
          // queue the next video so the next hover shows a new one
          idx = (idx + 1) % list.length;
          setTimeout(function () {
            if (card.classList.contains('is-playing')) return;
            vid.src = list[idx]; buffered = false; preload();
          }, 520);
        }
      });
    });
  }

  /* ---------- row arrows ---------- */
  d.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-g2-scroll]') : null;
    if (!b) return;
    var track = d.getElementById(b.getAttribute('aria-controls'));
    if (!track) return;
    var first = track.firstElementChild;
    var gap = parseFloat(w.getComputedStyle(track).columnGap) || 16;
    var step = first ? first.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
    var dir = b.getAttribute('data-g2-scroll') === 'prev' ? -1 : 1;
    track.scrollBy({ left: dir * step, behavior: reduce ? 'auto' : 'smooth' });
  });

  function init(root) { initFade(root || d); initHoverVideo(root || d); }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { init(d); });
  else init(d);
  d.addEventListener('shopify:section:load', function (e) { init(e.target); });

  w.G2 = { init: init, reduce: reduce, canHover: canHover };
})();
